import { createFileRoute } from "@tanstack/react-router";
import Sitemap from "@/pages/Sitemap";
export const Route = createFileRoute("/sitemap")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Sitemap | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Complete sitemap directory for Neuro Wellness TMS Centers of America. Find links to all pages, treatments, services, and legal policies in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Sitemap | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Complete sitemap directory for Neuro Wellness TMS Centers of America. Find links to all pages, treatments, services, and legal policies in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/sitemap",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/sitemap",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <Sitemap />;
}
